module.exports = __webpack_public_path__ + "static/media/search-button.a166e475.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/search-button.svg
// module id = 220
// module chunks = 0